﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorStatsCollectorContract = exports.ValidatorStatResponse = exports.ValidatorStat = void 0;
const ContractFacade_1 = require("./abstact/ContractFacade");
const ValidatorStatsCollectorABI_1 = require("./abi/ValidatorStatsCollectorABI");
class ValidatorStat {
}
exports.ValidatorStat = ValidatorStat;
class ValidatorStatResponse {
}
exports.ValidatorStatResponse = ValidatorStatResponse;
class ValidatorStatsCollectorContract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, ValidatorStatsCollectorABI_1.ValidatorStatsCollectorABI.GetABI());
    }
    getTotalIncomePLS() {
        return __awaiter(this, void 0, void 0, function* () { const value = yield this._call("totalIncome"); return this._toEther(value); });
    }
    getStatsFromEnd(skip) {
        return __awaiter(this, void 0, void 0, function* () {
            const respose = yield this._call("getStatsFromEnd", skip);
            if (!respose)
                return respose;
            const result = new ValidatorStatResponse();
            result._length = respose._length + "";
            result.list = [];
            for (let r of respose.list) {
                const s = new ValidatorStat();
                s.acc = this._toEther(r.acc);
                s.profitPerValidator = this._toEther(r.profitPerValidator);
                s.timestamp = r.timestamp + "";
                result.list.push(s);
            }
            return result;
        });
    }
}
exports.ValidatorStatsCollectorContract = ValidatorStatsCollectorContract;
//# sourceMappingURL=ValidatorStatsCollectorContract.js.map